export const pictureSystemType = {
    "ALL": "Все",
    "BANNER": "Баннер",
    "NEWS": "Новости",
    "PROMO": "Акции",
}